module.exports = __webpack_public_path__ + "img/History.0683b8cc.svg";